import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

const riverside = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 10, seriesName: 'distriSPOT Riverside' });
const northGate = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 6, seriesName: 'distriSPOT North Gate' });
const workshop = createSingleSeriesTimeSeriesMockData({ days: 30, scale: 3.5, seriesName: 'distriSPOT Workshop' });

export const STOCK_VOLUME_BY_SPOT_LINE_CHART_MOCK_DATA: Chart = {
    series: [riverside.series[0], northGate.series[0], workshop.series[0]]
};
